/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import { _x } from '@web-stories-wp/i18n';
import PropTypes from 'prop-types';

const title = _x('Oven', 'sticker name', 'web-stories');

function Oven({ style }) {
  return (
    <svg
      style={style}
      viewBox="0 0 66 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path d="M9 23H57V57H9V23Z" fill="#FFFEB2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63 18.5H3V61C3 61.5523 3.44772 62 4 62H62C62.5523 62 63 61.5523 63 61V18.5ZM63 15.5H3V4C3 3.44772 3.44772 3 4 3H62C62.5523 3 63 3.44772 63 4V15.5ZM66 4C66 1.79086 64.2091 0 62 0H4C1.79086 0 0 1.79086 0 4V61C0 63.2091 1.79086 65 4 65H62C64.2091 65 66 63.2091 66 61V4Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57 31.4154H9V56H57V31.4154ZM57 29.4154H9V24H57V29.4154ZM59 24C59 22.8954 58.1046 22 57 22H9C7.89543 22 7 22.8954 7 24V56C7 57.1046 7.89543 58 9 58H57C58.1046 58 59 57.1046 59 56V24Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7934 34.1778C27.2475 34.4921 27.3608 35.1151 27.0465 35.5692C26.8322 35.8787 26.5058 36.4519 26.2729 37.0983C26.033 37.7646 25.9411 38.375 26.038 38.8231C26.1744 39.4539 26.4899 40.0158 26.8874 40.7239C26.9401 40.8179 26.9943 40.9143 27.0496 41.0139C27.486 41.7984 28 42.7852 28 43.9655C28 44.8893 27.6765 45.8624 27.3338 46.6427C26.983 47.4412 26.563 48.1469 26.2707 48.5692C25.9564 49.0233 25.3334 49.1366 24.8793 48.8222C24.4252 48.5079 24.3119 47.8849 24.6263 47.4308C24.8511 47.106 25.2069 46.5116 25.5026 45.8384C25.8064 45.1468 26 44.4762 26 43.9655C26 43.3527 25.7382 42.7706 25.3018 41.9861C25.2536 41.8994 25.2027 41.8094 25.15 41.7163C24.7659 41.0379 24.2884 40.1944 24.0832 39.2459C23.8698 38.2595 24.1011 37.2262 24.3913 36.4206C24.6886 35.5952 25.0991 34.8684 25.402 34.4308C25.7163 33.9767 26.3393 33.8634 26.7934 34.1778Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.7934 34.1778C34.2475 34.4921 34.3608 35.1151 34.0465 35.5692C33.8322 35.8787 33.5058 36.4519 33.2729 37.0983C33.033 37.7646 32.9411 38.375 33.038 38.8231C33.1744 39.4539 33.4899 40.0158 33.8874 40.7239C33.9401 40.8179 33.9943 40.9143 34.0496 41.0139C34.486 41.7984 35 42.7852 35 43.9655C35 44.8893 34.6765 45.8624 34.3338 46.6427C33.983 47.4412 33.563 48.1469 33.2707 48.5692C32.9564 49.0233 32.3334 49.1366 31.8793 48.8222C31.4252 48.5079 31.3119 47.8849 31.6263 47.4308C31.8511 47.106 32.2069 46.5116 32.5026 45.8384C32.8064 45.1468 33 44.4762 33 43.9655C33 43.3527 32.7382 42.7706 32.3018 41.9861C32.2536 41.8994 32.2027 41.8094 32.15 41.7163C31.7659 41.0379 31.2884 40.1944 31.0832 39.2459C30.8698 38.2595 31.1011 37.2262 31.3913 36.4206C31.6886 35.5952 32.0991 34.8684 32.402 34.4308C32.7163 33.9767 33.3393 33.8634 33.7934 34.1778Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.7934 34.1778C41.2475 34.4921 41.3608 35.1151 41.0465 35.5692C40.8322 35.8787 40.5058 36.4519 40.2729 37.0983C40.033 37.7646 39.9411 38.375 40.038 38.8231C40.1744 39.4539 40.4899 40.0158 40.8874 40.7239C40.9401 40.8179 40.9943 40.9143 41.0496 41.0139C41.486 41.7984 42 42.7852 42 43.9655C42 44.8893 41.6765 45.8624 41.3338 46.6427C40.983 47.4412 40.563 48.1469 40.2707 48.5692C39.9564 49.0233 39.3334 49.1366 38.8793 48.8222C38.4252 48.5079 38.3119 47.8849 38.6263 47.4308C38.8511 47.106 39.2069 46.5116 39.5026 45.8384C39.8064 45.1468 40 44.4762 40 43.9655C40 43.3527 39.7382 42.7706 39.3018 41.9861C39.2536 41.8994 39.2027 41.8094 39.15 41.7163C38.7659 41.0379 38.2884 40.1944 38.0832 39.2459C37.8698 38.2595 38.1011 37.2262 38.3913 36.4206C38.6886 35.5952 39.0991 34.8684 39.402 34.4308C39.7163 33.9767 40.3393 33.8634 40.7934 34.1778Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52 53.5H13.5V51.5H52V53.5Z"
        fill="#005CD6"
      />
    </svg>
  );
}

Oven.propTypes = {
  style: PropTypes.object,
};

export default {
  aspectRatio: 66 / 65,
  svg: Oven,
  title,
};
